export const safeParseJSON = <T = any>(json: string) => {
    try {
        return JSON.parse(json) as T;
    } catch {
        return null;
    }
}